export default __webpack_public_path__ + "static/media/sj-logo-round.111cfa57.png";